import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'quality'
})
export class QualityPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    // console.log("quality", value)
    if (value === 0) return 'High';
    if (value === 1) return 'Medium';
    if (value === 2) return 'Low';
  }

}
